/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Spec_SheetInputs */

const en_doc_type_spec_sheet = /** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spec Sheet`)
};

const id_doc_type_spec_sheet = /** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembar Spesifikasi`)
};

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const es_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const fr_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const de_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const ja_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const zh_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const ar_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const it_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const ru_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const pt_doc_type_spec_sheet = en_doc_type_spec_sheet;

/** @type {(inputs: Doc_Type_Spec_SheetInputs) => LocalizedString} */
const ko_doc_type_spec_sheet = en_doc_type_spec_sheet;

/**
* | output |
* | --- |
* | "Spec Sheet" |
*
* @param {Doc_Type_Spec_SheetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_spec_sheet = /** @type {((inputs?: Doc_Type_Spec_SheetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Spec_SheetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_spec_sheet(inputs)
	if (locale === "es") return es_doc_type_spec_sheet(inputs)
	if (locale === "fr") return fr_doc_type_spec_sheet(inputs)
	if (locale === "de") return de_doc_type_spec_sheet(inputs)
	if (locale === "ja") return ja_doc_type_spec_sheet(inputs)
	if (locale === "zh") return zh_doc_type_spec_sheet(inputs)
	if (locale === "ar") return ar_doc_type_spec_sheet(inputs)
	if (locale === "id") return id_doc_type_spec_sheet(inputs)
	if (locale === "it") return it_doc_type_spec_sheet(inputs)
	if (locale === "ru") return ru_doc_type_spec_sheet(inputs)
	if (locale === "pt") return pt_doc_type_spec_sheet(inputs)
	return ko_doc_type_spec_sheet(inputs)
});